export const PHONE_YGT = "08000436644";
export const DOWNLOAD_PDF = "download-pdf";
export const DATE_FORMAT = "DD/MM/YYYY";
export const PREVIEW_BAR_HEIGHT = { desktop: 72, mobile: 108 } as const;
